import { SearchProps } from '~components/form-fields/search';

import { selectLookupAppointmentServiceTypes } from '~appointments/selectors/serviceTypes';
import { isEncryptionEnabled } from '~libs/encryptionSettings';

export const searchFields: SearchProps = {
  client: {
    defaultShow: true,
    type: 'text-like',
    field: ['first_name', 'surname', 'full_name'],
    placeholder: 'Client Name',
    caption: 'Client',
    hidden: isEncryptionEnabled,
  },
  start_date: {
    defaultShow: true,
    type: 'date-range',
    field: 'start_date',
    caption: 'Start Date',
  },
  end_date: {
    defaultShow: false,
    type: 'date-range',
    field: 'end_date',
    caption: 'End Date',
  },
  service_type_id: {
    defaultShow: false,
    type: 'multi-lookup',
    field: 'service_type_id',
    placeholder: 'All',
    caption: 'Service Type',
    selectorOptions: selectLookupAppointmentServiceTypes,
  },
};

export default searchFields;
